import { Row, Col } from 'reactstrap';
import { useState } from 'react';
import PaginatedTableLotes from '../../components/reportes/lotes/PaginatedTableLotes';
// import BarChartLotes from '../../components/reportes/lotes/BarChartLotes';
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { PageTitle } from '../../components/common';

const Lotes = () => {  
    // Para guardar la tabla de Lotes.
    const [tableData, setTable] = useState([]);
    const [nro_cliente, setSelectedClient]: any = useState(null);
    
    // Con esto filtramos la data para el grafico de barras
    // si es "all" muestra por cliente, caso contrario
    // muestra lote de cada cliente.
    const result: any = [];
    tableData.reduce((res: any, value: any) => {
      if (nro_cliente == null || nro_cliente.length > 1) {
        // Check if cliente exist.
        if (!res[value.nro_cliente]) {
          res[value.nro_cliente] = { nro_cliente: value.nro_cliente, kg_lotes:0 };
          result.push(res[value.nro_cliente])
        }

        res[value.nro_cliente].kg_lotes += value.kg_lotes;
      }

      else {
        if (value.nro_cliente === nro_cliente[0]) {
          if(!res[value.nro_lote]) {
            res[value.nro_lote] = { nro_cliente: value.nro_lote, kg_lotes:0 };
            result.push(res[value.nro_lote])
          }
          // Ponemos calidad_promedio en lugar de kilos.
          res[value.nro_lote].kg_lotes += value.calidad_promedio;
        }
      };
      return res;
    }
    , {});    

    // <Row>
    // <Col xs="12" md="12" lg="12">
    //   <Row>
    //       <div style={{ margin: 'auto', width:'100%', height:'400px'}}>
    //         <BarChartLotes
    //           title={nro_cliente == null || nro_cliente.length > 1 ? 'Kilogramos por Cliente' : `Cliente ${nro_cliente[0]} - Calidad Promedio por Lote`}
    //           bardata={result}
    //           nro_cliente={nro_cliente}>
    //       </BarChartLotes>
    //       </div>
    //   </Row>
    // </Col>
    // </Row>
    
    return (
      <div style={{ padding: '0' }}>
        <PageTitle>Lotes Comerciales</PageTitle>
        <Row className='my-4'>
          <Col xs="12" md="12" lg="12">   
            <PaginatedTableLotes
            csvName={"reporte_lotes.xlsx"}
            getTableData={setTable}
            getNroCliente={setSelectedClient}
            >
            </PaginatedTableLotes>  
          </Col>
        </Row>
      </div>
    );
};

export default withAuthenticationRequired(Lotes); //Lotes;